'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    CHILD_STATE: null,
    useRouteCache: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CHILD_STATE () {
        return CHILD_STATE;
    },
    get useRouteCache () {
        return useRouteCache;
    }
});
function _react() {
    const data = /*#__PURE__*/ _interop_require_wildcard(require("react"));
    _react = function() {
        return data;
    };
    return data;
}
const _isRecordEqual = require("./isRecordEqual");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const CHILD_STATE = Symbol('CHILD_STATE');
function useRouteCache(routes) {
    // Cache object which holds route objects for each screen
    const cache = _react().useMemo(()=>({
            current: new Map()
        }), []);
    cache.current = routes.reduce((acc, route)=>{
        const previous = cache.current.get(route.key);
        const { state, ...routeWithoutState } = route;
        let proxy;
        if (previous && (0, _isRecordEqual.isRecordEqual)(previous, routeWithoutState)) {
            // If a cached route object already exists, reuse it
            proxy = previous;
        } else {
            proxy = routeWithoutState;
        }
        if (process.env.NODE_ENV !== 'production') {
            // FIXME: since the state is updated with mutation, the route object cannot be frozen
            // As a workaround, loop through the object and make the properties readonly
            for(const key in proxy){
                // @ts-expect-error: this is fine since we are looping through the object
                const value = proxy[key];
                Object.defineProperty(proxy, key, {
                    enumerable: true,
                    configurable: true,
                    writable: false,
                    value
                });
            }
        }
        Object.defineProperty(proxy, CHILD_STATE, {
            enumerable: false,
            configurable: true,
            value: state
        });
        acc.set(route.key, proxy);
        return acc;
    }, new Map());
    return Array.from(cache.current.values());
}

//# sourceMappingURL=useRouteCache.js.map
